import { useEffect } from 'react';
import { getTelegram } from '../telegram';
import { WebBackButton } from '../components/WebNav';
import type { CoffeeShop } from '../types';

interface Props {
  shops: CoffeeShop[];
  onSelect: (shop: CoffeeShop) => void;
  onBack: () => void;
  loading: boolean;
}

export default function CoffeeShopSelectPage({ shops, onSelect, onBack, loading }: Props) {
  useEffect(() => {
    const tg = getTelegram();
    if (!tg) return;
    tg.BackButton.show();
    tg.BackButton.onClick(onBack);
    tg.MainButton.hide();
    if (loading) tg.MainButton.showProgress(false);
    else tg.MainButton.hideProgress();
    return () => { tg.BackButton.offClick(onBack); tg.BackButton.hide(); };
  }, [onBack, loading]);

  return (
    <div className="container" style={{ padding: '16px 16px 32px' }}>
      <WebBackButton onClick={onBack} label="‹ В корзину" />
      <h3 style={{ margin: '0 0 4px', fontSize: 18 }}>Выберите кофейню</h3>
      <p className="hint" style={{ margin: '0 0 20px' }}>Заказ будет доставлен по выбранному адресу</p>

      {loading ? (
        <p className="hint">Оформление заказа…</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {shops.map(shop => (
            <button
              key={shop.id}
              onClick={() => onSelect(shop)}
              style={{
                background: 'var(--tg-secondary-bg)',
                border: 'none',
                borderRadius: 14,
                padding: '14px 16px',
                textAlign: 'left',
                cursor: 'pointer',
                color: 'var(--tg-text)',
                fontFamily: 'inherit',
                width: '100%',
              }}
            >
              <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 4 }}>{shop.name}</div>
              <div className="hint" style={{ fontSize: 13 }}>{shop.address}</div>
              <div className="hint" style={{ fontSize: 12, marginTop: 4 }}>
                {shop.delivery_type === 'city' ? 'Городская доставка' : 'Межгородская доставка'}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
